export default class Carbravo {
  public exports = {};
  public constructor() {
    this.removeLogoLink();
  }

  // If this file is loaded, the dealer has Carbravo branding enabled but their DRP links aren't set up yet.
  // We need to remove the link wrapping the logo, which is in the website template and not directly controlled by dev code.
  private readonly removeLogoLink = () => {
    const logos = Array.from(
      document.querySelectorAll(
        ".desktop .logoCarBravo, .mobile .logoCarBravo"
      ) as NodeListOf<HTMLElement>
    );
    for (const logo of logos) {
      const link = logo.querySelector<HTMLLinkElement>("a");
      if (!link) {
        continue;
      }
      const img = link.querySelector<HTMLImageElement>("img");
      link.replaceWith(img ?? "");
      logo.style.display = "inline-block";
    }
  };
}

DoUtility.SelfInstantiateOnLoad(Carbravo);
